// Sock Rain – instant trigger (pointerdown), no duplicates, keeps window.SOCK_POS
(function () {
  const onReady = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn, { once: true })
      : fn();

  // ---- Config you already use ----
  const LANES_VW = [4, 16, 28, 40, 56, 70, 12, 24, 36, 52]; // start lanes
  const BASE_FROM_RIGHT_VW = 12;                             // base distance from right
  const FAN_X_PX =  [0, 40, 90, 140, 60, 110, 20, 75, 130, 50];
  const FAN_Y_PX =  [92,118,136,108,150,128,172,142,160,120];
  const BASE_SHIFT_PX = 300; // your global left shift (positive = weiter nach links)
  const PER_ITEM_DELAY_S = 0.12;  // rain density
  const ATTACH_DELAY_MS  = 40;    // micro-sequencing on DOM attach

  // ---- Runtime guards / state ----
  let activeRunId = 0;
  let pendingTimers = [];
  const clearTimers = () => { pendingTimers.forEach(t => clearTimeout(t)); pendingTimers = []; };

  // ---- Preload to avoid image stall ----
  const preloadCache = new Map();
  function preloadAssets() {
    const ASSETS = (window.SOCK_ASSETS || []);
    ASSETS.forEach(src => {
      if (!src || preloadCache.has(src)) return;
      const img = new Image();
      img.loading = 'eager';
      img.decoding = 'async';
      img.src = src;
      preloadCache.set(src, true);
    });
  }

  // ---- DOM helpers ----
  function ensureLayer() {
    let el = document.getElementById('sock-rain');
    if (!el) {
      el = document.createElement('div');
      el.id = 'sock-rain';
      document.body.appendChild(el);
    }
    el.style.display = 'block';
    return el;
  }
  
  function clearLayer() {
    const el = document.getElementById('sock-rain');
    if (el) {
      el.style.display = 'none';
      el.innerHTML = '';
    }
  }

  const unit = (v, u = 'px') => (typeof v === 'number' ? `${v}${u}` : v);

  // ---- Spawn with duplicate/run protection ----
  function spawnOrderly() {
    // Cancel previous run immediately
    clearTimers();
    clearLayer();
    const myRun = ++activeRunId;

    const ASSETS = (window.SOCK_ASSETS || []).slice(0, 50);
    if (!ASSETS.length) return;

    const layer = ensureLayer();
    layer.innerHTML = '';

    ASSETS.forEach((src, i) => {
      const t = setTimeout(() => {
        if (myRun !== activeRunId) return; // aborted

        const item = document.createElement('div');
        item.className = 'sr-item';

        // small natural variance
        const size = 60 + Math.random() * 16;
        const rot  = -20 + Math.random() * 16;
        const spin = -12 + Math.random() * 24;
        const durS = 4 + Math.random() * 0.6;

        // START X (lane)
        const lane = LANES_VW[i % LANES_VW.length];
        item.style.setProperty('--sx', `${lane}vw`);

        // CONFIG OVERRIDES
        const cfg = Array.isArray(window.SOCK_POS) ? window.SOCK_POS[i] : null;

        if (cfg && (cfg.stackX || cfg.stackY)) {
          if (cfg.stackX) item.style.setProperty('--stackX', cfg.stackX);
          if (cfg.stackY) item.style.setProperty('--stackY', cfg.stackY);
        } else {
          const fanX = (FAN_X_PX[i % FAN_X_PX.length] || 0) + BASE_SHIFT_PX;
          const fanY = (FAN_Y_PX[i % FAN_Y_PX.length] || 120);
          item.style.setProperty('--stackX', `calc(${BASE_FROM_RIGHT_VW}vw + ${fanX}px)`);
          item.style.setProperty('--stackY', unit(fanY, 'px'));
        }

        if (cfg && cfg.startX) item.style.setProperty('--sx', cfg.startX);
        item.style.setProperty('--size', cfg && cfg.size ? unit(cfg.size) : `${size}px`);
        item.style.setProperty('--rot',  cfg && cfg.rot  != null ? unit(cfg.rot,  'deg') : `${rot}deg`);
        item.style.setProperty('--spin', cfg && cfg.spin != null ? unit(cfg.spin, 'deg') : `${spin}deg`);

        item.style.animationDuration = `${durS}s`;
        item.style.animationDelay    = `${(i * PER_ITEM_DELAY_S) - 2.3}s`;

        const img = document.createElement('img');
        img.src = src;
        img.alt = 'sock';
        // force eager so first frame paints instantly
        img.loading = 'eager';
        img.decoding = 'async';

        item.appendChild(img);
        layer.appendChild(item);
      }, i * ATTACH_DELAY_MS);
      pendingTimers.push(t);
    });
  }

 function wireTriggers() {
  const details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;

  // 1) Fire immediately when user *presses* the burger (before open anim)
  const burger = document.querySelector('summary.header__icon--menu');
  if (burger) {
    burger.addEventListener('pointerdown', () => {
      // Only start if the drawer is not already open (avoid double-run)
      if (!details.hasAttribute('open')) spawnOrderly();
    }, { passive: true });
  }

  // 2) Overlay-Click: Instant hide
  const overlay = document.querySelector('.menu-drawer__overlay');
  if (overlay) {
    overlay.addEventListener('click', () => {
      const el = document.getElementById('sock-rain');
      if (el) el.style.display = 'none';
      clearTimers();
      activeRunId++;
    });
  }

  // 3) Toggle event (fallback + spawning)
  details.addEventListener('toggle', () => {
    if (details.open) {
      spawnOrderly();
    } else {
      // Backup cleanup wenn kein anderer Trigger griff
      const el = document.getElementById('sock-rain');
      if (el) el.style.display = 'none';
      clearTimers();
      clearLayer();
    }
  });

  // 4) ESC cleanup
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const el = document.getElementById('sock-rain');
      if (el) el.style.display = 'none';
      clearTimers();
      clearLayer();
      activeRunId++;
    }
  });
}

  onReady(() => {
    preloadAssets();
    wireTriggers();
  });
})();